// Home.jsx (معدل مع إمكانية تغيير رقم الواتساب)
import React, { useEffect, useState } from "react";
import "./Home.css";
import { 
  FaBullhorn, FaAd, FaSearch, FaPalette, 
  FaFileAlt, FaChartLine, FaCogs, FaHeadset, FaPaintBrush,
  FaExternalLinkAlt, FaFacebookF, FaInstagram,
  FaGoogle, FaPenFancy
} from "react-icons/fa";

// ✅ استيراد الصورة من مجلد assets
import whatsappBotImage from "../assets/robot.png";

const Home = () => {
  const [lang, setLang] = useState("ar");

  const images = [
    "https://images.unsplash.com/photo-1557804506-669a67965ba0?q=80&w=1600&auto=format&fit=crop",
    "https://images.unsplash.com/photo-1552664730-d307ca884978?q=80&w=1600&auto=format&fit=crop",
    "https://images.unsplash.com/photo-1600880292203-757bb62b4baf?q=80&w=1600&auto=format&fit=crop",
  ];
  
  const [current, setCurrent] = useState(0);
  const [filter, setFilter] = useState("all");

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % images.length);
    }, 4000);
    return () => clearInterval(interval);
  }, [images.length]);

  const translations = {
    heroTitle: { ar: "حلول تسويق رقمي متقدمة لعملك", en: "Advanced Digital Marketing Solutions for Your Business" },
    heroDescription: { ar: "نُمكّن الشركات من النمو والوصول لجمهور أوسع من خلال استراتيجيات تسويقية مبتكرة وحملات إعلانية فعّالة", en: "We empower businesses to grow and reach wider audiences through innovative marketing strategies and effective advertising campaigns" },
    ourServicesBtn: { ar: "خدماتنا", en: "Our Services" },
    servicesTitle: { ar: "خدماتنا المميزة", en: "Our Featured Services" },
    services: {
      ar: [
        { title: "التسويق عبر وسائل التواصل", description: "إدارة حملات احترافية على جميع المنصات" },
        { title: "الإعلانات المدفوعة", description: "حملات إعلانية مستهدفة بعائد استثمار عالي" },
        { title: "تحسين محركات البحث SEO", description: "تصدر نتائج البحث وزيادة الزيارات" },
        { title: "تصميم الهوية التجارية", description: "تصميم شعارات وهويات بصرية احترافية" },
        { title: "التسويق بالمحتوى", description: "محتوى إبداعي يجذب ويحول الزوار لعملاء" },
        { title: "تحليلات التسويق", description: "تقارير دقيقة لقياس الأداء والنتائج" }
      ],
      en: [
        { title: "Social Media Marketing", description: "Professional campaign management across all platforms" },
        { title: "Paid Advertising", description: "Targeted ad campaigns with high ROI" },
        { title: "SEO Optimization", description: "Top search rankings and increased traffic" },
        { title: "Brand Identity Design", description: "Professional logo and visual identity design" },
        { title: "Content Marketing", description: "Creative content that attracts and converts visitors" },
        { title: "Marketing Analytics", description: "Accurate reports to measure performance and results" }
      ]
    },
    whyTitle: { ar: "ليه تختارنا", en: "Why Choose Us" },
    whyItems: {
      ar: [
        { title: "استراتيجيات مخصصة", description: "نقدم حلول تسويقية حسب احتياجاتك" },
        { title: "دعم فني مستمر", description: "فريق دعم جاهز 24/7" },
        { title: "تصميم احترافي", description: "تصميمات إبداعية تجذب الانتباه" },
        { title: "خبرة تسويقية", description: "خبرة واسعة في التسويق الرقمي" }
      ],
      en: [
        { title: "Custom Strategies", description: "We provide marketing solutions tailored to your needs" },
        { title: "Continuous Support", description: "Support team ready 24/7" },
        { title: "Professional Design", description: "Creative designs that capture attention" },
        { title: "Marketing Expertise", description: "Extensive experience in digital marketing" }
      ]
    },
    portfolioTitle: { ar: "نماذج أعمالنا", en: "Our Work Samples" },
    portfolioSubtitle: { ar: "نقدم حلولاً تسويقية مبتكرة للشركات والعلامات التجارية، شاهد نماذج من حملاتنا الناجحة", en: "We provide innovative marketing solutions for businesses and brands. See samples of our successful campaigns" },
    categories: {
      ar: [
        { id: "all", name: "الكل" },
        { id: "حملات", name: "حملات إعلانية" },
        { id: "سوشيال", name: "سوشيال ميديا" },
        { id: "هوية", name: "هوية تجارية" },
        { id: "محتوى", name: "محتوى تسويقي" }
      ],
      en: [
        { id: "all", name: "All" },
        { id: "حملات", name: "Ad Campaigns" },
        { id: "سوشيال", name: "Social Media" },
        { id: "هوية", name: "Brand Identity" },
        { id: "محتوى", name: "Marketing Content" }
      ]
    },
    viewAllBtn: { ar: "شوف كل الأعمال", en: "View All Works" },
    projects: {
      ar: [
        { title: "حملة إعلانية على فيسبوك", category: "حملات", description: "حملة إعلانية ناجحة حققت 300% زيادة في المبيعات خلال شهر واحد", tags: ["إعلانات مدفوعة"] },
        { title: "إدارة حسابات سوشيال ميديا", category: "سوشيال", description: "إدارة شاملة لحسابات التواصل الاجتماعي مع زيادة 500% في التفاعل", tags: ["سوشيال ميديا"] },
        { title: "تصميم هوية تجارية متكاملة", category: "هوية", description: "تصميم شعار وهوية بصرية كاملة لعلامة تجارية ناشئة", tags: ["تصميم جرافيك"] },
        { title: "استراتيجية محتوى تسويقي", category: "محتوى", description: "خطة محتوى شاملة أدت لزيادة 400% في الزيارات العضوية", tags: ["كتابة محتوى"] },
        { title: "حملة إعلانية على جوجل", category: "حملات", description: "حملة Google Ads حققت عائد استثمار 600%", tags: ["إعلانات مدفوعة"] },
        { title: "استراتيجية انستجرام", category: "سوشيال", description: "نمو 10,000 متابع حقيقي في 3 أشهر", tags: ["سوشيال ميديا"] },
        { title: "إعادة تصميم هوية تجارية", category: "هوية", description: "تحديث كامل للهوية البصرية لشركة عقارية", tags: ["تصميم جرافيك"] },
        { title: "حملة تسويق بالمحتوى", category: "محتوى", description: "محتوى إبداعي أدى لزيادة 250% في التحويلات", tags: ["كتابة محتوى"] }
      ],
      en: [
        { title: "Facebook Ad Campaign", category: "حملات", description: "Successful ad campaign achieving 300% increase in sales within one month", tags: ["Paid Advertising"] },
        { title: "Social Media Management", category: "سوشيال", description: "Comprehensive social media management with 500% increase in engagement", tags: ["Social Media"] },
        { title: "Complete Brand Identity Design", category: "هوية", description: "Logo and complete visual identity design for a startup brand", tags: ["Graphic Design"] },
        { title: "Content Marketing Strategy", category: "محتوى", description: "Comprehensive content plan leading to 400% increase in organic traffic", tags: ["Content Writing"] },
        { title: "Google Ad Campaign", category: "حملات", description: "Google Ads campaign achieving 600% ROI", tags: ["Paid Advertising"] },
        { title: "Instagram Strategy", category: "سوشيال", description: "Growth of 10,000 real followers in 3 months", tags: ["Social Media"] },
        { title: "Brand Identity Redesign", category: "هوية", description: "Complete visual identity update for a real estate company", tags: ["Graphic Design"] },
        { title: "Content Marketing Campaign", category: "محتوى", description: "Creative content leading to 250% increase in conversions", tags: ["Content Writing"] }
      ]
    },
    whatsappTooltip: { ar: "تواصل مع البوت", en: "Contact Bot" }
  };

  const t = translations;
  const currentLang = lang;

  const services = [
    { id: 1, icon: <FaBullhorn />, color: "#ff6b35" },
    { id: 2, icon: <FaAd />, color: "#ff6b35" },
    { id: 3, icon: <FaSearch />, color: "#ff6b35" },
    { id: 4, icon: <FaPalette />, color: "#ff6b35" },
    { id: 5, icon: <FaFileAlt />, color: "#ff6b35" },
    { id: 6, icon: <FaChartLine />, color: "#ff6b35" }
  ];

  const whyChooseUsIcons = [
    { id: 1, icon: <FaCogs />, color: "#ff6b35" },
    { id: 2, icon: <FaHeadset />, color: "#ff6b35" },
    { id: 3, icon: <FaPaintBrush />, color: "#ff6b35" },
    { id: 4, icon: <FaBullhorn />, color: "#ff6b35" }
  ];

  const projects = [
    { id: 1, image: "https://images.unsplash.com/photo-1563986768609-322da13575f3?q=80&w=1600&auto=format&fit=crop", icon: <FaFacebookF /> },
    { id: 2, image: "https://images.unsplash.com/photo-1611926653458-09294b3142bf?q=80&w=1600&auto=format&fit=crop", icon: <FaInstagram /> },
    { id: 3, image: "https://images.unsplash.com/photo-1542744094-3a31f272c490?q=80&w=1600&auto=format&fit=crop", icon: <FaPalette /> },
    { id: 4, image: "https://images.unsplash.com/photo-1432888498266-38ffec3eaf0a?q=80&w=1600&auto=format&fit=crop", icon: <FaPenFancy /> },
    { id: 5, image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?q=80&w=1600&auto=format&fit=crop", icon: <FaGoogle /> },
    { id: 6, image: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?q=80&w=1600&auto=format&fit=crop", icon: <FaInstagram /> },
    { id: 7, image: "https://images.unsplash.com/photo-1557838923-2985c318be48?q=80&w=1600&auto=format&fit=crop", icon: <FaPalette /> },
    { id: 8, image: "https://images.unsplash.com/photo-1499750310107-5fef28a66643?q=80&w=1600&auto=format&fit=crop", icon: <FaPenFancy /> }
  ];

  const projectsData = projects.map((proj, idx) => ({
    ...proj,
    title: t.projects[currentLang][idx].title,
    category: t.projects[currentLang][idx].category,
    description: t.projects[currentLang][idx].description,
    tags: t.projects[currentLang][idx].tags
  }));

  const categories = t.categories[currentLang];
  const filteredProjects = filter === "all" ? projectsData : projectsData.filter(p => p.category === filter);

  const handleOurServices = () => {
    alert(currentLang === "ar" ? "جاري تحميل خدماتنا المميزة..." : "Loading our featured services...");
    const servicesSection = document.querySelector('.services-section');
    if (servicesSection) servicesSection.scrollIntoView({ behavior: 'smooth' });
  };

  // ✅ مكان تغيير رقم الواتساب - استبدل الرقم التالي بالرقم المطلوب
  const WHATSAPP_NUMBER = "+201037334294";  // غيّر هذا الرقم إلى ما تريد

  const handleWhatsAppClick = () => {
    window.open(`https://wa.me/${WHATSAPP_NUMBER}`, "_blank");
  };

  const handleViewAllProjects = () => {
    alert(currentLang === "ar" ? "سيتم عرض جميع المشاريع قريباً" : "All projects will be shown soon");
    setFilter("all");
  };

  const handleServiceClick = (serviceTitle) => {
    alert(`${currentLang === "ar" ? "جاري تحميل صفحة خدمة:" : "Loading service page:"} ${serviceTitle}`);
  };

  const handleWhyChooseUsClick = (itemTitle) => {
    alert(`${currentLang === "ar" ? "معلومات عن:" : "Information about:"} ${itemTitle}`);
  };

  const LangSwitcher = () => (
    <button onClick={() => setLang(lang === "ar" ? "en" : "ar")} style={{ position: "fixed", top: "85px", right: "20px", zIndex: 1000, background: "#1E6F8E", color: "white", border: "none", borderRadius: "40px", padding: "8px 16px", fontWeight: "bold", cursor: "pointer", transition: "all 0.3s ease", fontFamily: "inherit", boxShadow: "0 2px 8px rgba(0,0,0,0.2)" }}>
      {lang === "ar" ? "English" : "العربية"}
    </button>
  );

  return (
    <div className="home-container" dir={lang === "ar" ? "rtl" : "ltr"}>
      {/* LangSwitcher Removed */}

      <section className="hero-section">
        <div className="hero-slider">
          {images.map((img, index) => (
            <img key={index} src={img} alt={`Marketing ${index + 1}`} className={index === current ? "active" : ""} />
          ))}
        </div>
        <div className="hero-overlay">
          <h1><span>{t.heroTitle[lang]}</span></h1>
          <p>{t.heroDescription[lang]}</p>
          <div className="hero-buttons">
            <button className="btn-secondary" onClick={handleOurServices}>{t.ourServicesBtn[lang]}</button>
          </div>
        </div>
      </section>

      <section className="services-section">
        <h2 className="services-title">{t.servicesTitle[lang]}</h2>
        <div className="services-grid">
          {services.map((service, idx) => (
            <div key={service.id} className="service-card" onClick={() => handleServiceClick(t.services[lang][idx].title)}>
              <div style={{ color: service.color }}>{service.icon}</div>
              <h3>{t.services[lang][idx].title}</h3>
              <p>{t.services[lang][idx].description}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="why-section">
        <h2 className="why-title">{t.whyTitle[lang]}</h2>
        <div className="why-grid">
          {whyChooseUsIcons.map((item, idx) => (
            <div key={item.id} className="why-card" onClick={() => handleWhyChooseUsClick(t.whyItems[lang][idx].title)}>
              <div style={{ color: item.color }}>{item.icon}</div>
              <h3>{t.whyItems[lang][idx].title}</h3>
              <p>{t.whyItems[lang][idx].description}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="portfolio-section">
        <div className="portfolio-header">
          <h2 className="portfolio-title">{t.portfolioTitle[lang]}</h2>
          <p className="portfolio-subtitle">{t.portfolioSubtitle[lang]}</p>
        </div>
        <div className="portfolio-filters">
          {categories.map((cat) => (
            <button key={cat.id} className={`filter-btn ${filter === cat.id ? "active" : ""}`} onClick={() => setFilter(cat.id)}>
              {cat.name}
            </button>
          ))}
        </div>
        <div className="portfolio-grid">
          {filteredProjects.map((project) => (
            <div key={project.id} className="portfolio-card">
              <div className="card-image"><img src={project.image} alt={project.title} /></div>
              <div className="card-content">
                <div className="card-header"><div className="card-icon">{project.icon}</div><h3 className="card-title">{project.title}</h3></div>
                <p className="card-description">{project.description}</p>
                <div className="card-tags">{project.tags.map((tag, idx) => <span key={idx} className="tag">{tag}</span>)}</div>
                <div className="card-footer"><span className="project-category">{project.category}</span></div>
              </div>
            </div>
          ))}
        </div>
        <div className="view-all">
          <button className="view-all-btn" onClick={handleViewAllProjects}>{t.viewAllBtn[lang]} <FaExternalLinkAlt /></button>
        </div>
      </section>

      <div className="whatsapp-float" onClick={handleWhatsAppClick}>
        <img src={whatsappBotImage} alt="WhatsApp Bot" style={{ width: "50px", height: "50px", borderRadius: "50%", objectFit: "cover" }} />
        <div className="whatsapp-tooltip">{t.whatsappTooltip[lang]}</div>
      </div>
    </div>
  );
};

export default Home;